import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const ftbQuestionPlayerStyles = css`
  &.heading-m {
    font-size: 2rem;
    font-weight: normal;
    line-height: 5.4rem;
  }
  font-size: 2rem;
  font-weight: normal;
  line-height: 5.4rem;
  vertical-align: middle;

  @media ${BREAKPOINT_QUERIES.Mobile} {
    &.heading-m {
      font-size: 1.6rem;
      line-height: 4rem;
    }
    font-size: 1.6rem;
    line-height: 4rem;
  }
`;

export const selectBoxStyle = '';
